import { useSelector } from 'react-redux';
import { TcsmStates } from '../../../root/tcsm-model';
import { EmploymentProps } from '../models/arc-epi-props';

export function useEmploymentSetting() {

    const employmentSetting = useSelector<TcsmStates, EmploymentProps>(state => state.epiProps?.employmentSettingsState?.epiContent);

    return employmentSetting;
}